import React, {  } from 'react';

import { collateOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { ArraySortInput } from './Array.sort';

export const ArraySort = () => (
	<IntlFunction
		input={ArraySortInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort"
		header="Array.prototype.sort"
		description={
`Sorts the elements of an array [in place](https://en.wikipedia.org/wiki/In-place_algorithm) and returns the sorted array. The default sort order is ascending, built upon converting the elements into strings, then comparing their sequences of UTF-16 code units values.

The time and space complexity of the sort cannot be guaranteed as it depends on the implementation.`
		}
		options={collateOptions}
		ruleSet={[]}
		template="##input:raw##.sort(new Intl.Collator(##locale##, ##options##).compare)" />
)